<template>
  <div style="padding: 20px">
    <Row :gutter="16">
      <Col :md="12">
        <Card>
          <h2>Importazioni Standard</h2>
          <hr />
          <p>
            Scarica per ogni importazione il modello excel e sostituisci i dati dell'esempio con i dati che vuoi caricare.
          </p>
        </Card>
        <br />
        <Row :gutter="16">
          <Col :md="12" v-for="f in files.filter(x => x.is_std)" :key="f.name">
            <Card style="text-align:center">
              <h2>{{ f.label }}</h2>
              <a v-if="f.example" :href="f.example" target="_blank">Scarica esempio</a>
              <div v-text="f.notes"></div>
              <br />
              <Upload
                type="drag"
                accept=".xls"
                :on-error="(a, body, c) => $error({ body })"
                :on-success="() => $success('File importato con successo')"
                :action="$apiurl + '/import/' + f.name"
                :headers="{ Authorization: `Bearer ${$store.session.token}` }"
                :before-upload="sicuri"
                :data="{ company_id: $store.company.id }"
              >
                <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>Trascina il file o clicca qui</p>
                </div>
              </Upload>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col :md="12">
        <Card>
          <h2>Importazione dati da Bartolomeo/Ancescao</h2>
          <hr />
          <p>
            Qui puoi importare tutti i file generati con il gestionale Bartolomeo, divisi per tipologia.
          </p>
          <hr />
          <div style="color: var(--error-color)">
            <h4>Attenzione!</h4>
            Importare i file potrebbe provocare inconsistenze nei dati già presenti in {{ $store.config.NAME }}, si
            prega quindi di usare questa funzionalità solo nella fase iniziale.
            <br />
            <p>Procedere con le importazioni da sinistra verso destra</p>
          </div>
        </Card>
        <br />
        <Row :gutter="16">
          <Col :md="12" v-for="f in files.filter(x => !x.is_std)" :key="f.name">
            <Card style="text-align:center">
              <h2>{{ f.label }}</h2>
              <br />
              <Upload
                type="drag"
                accept=".xls"
                :on-error="(a, body, c) => $error({ body })"
                :on-success="() => $success('File importato con successo')"
                :action="$apiurl + '/import/' + f.name"
                :headers="{ Authorization: `Bearer ${$store.session.token}` }"
                :before-upload="sicuri"
                :data="{ company_id: $store.company.id }"
              >
                <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>Trascina il file o clicca qui</p>
                </div>
              </Upload>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      console,
      files: [
        {
          name: "soci-standard",
          label: "Soci",
          example: 'esempio import soci.xls',
          notes: 'Verranno automaticamente riconosciuti eventuali soci esistenti in base alla colonna NUMERO. Tali soci verranno aggiornati con i dati presenti nell\'excel.',
          is_std: true,
        },
        {
          name: "fornitori",
          label: "Fornitori",
        },
        {
          name: "fatture",
          label: "Fatture",
        },
        {
          name: "prima-nota",
          label: "Registro prima nota",
        },
        {
          name: "soci",
          label: "Importazione soci",
        },
        {
          name: "beni",
          label: "Importazione beni",
        },
      ],
    };
  },
  created() {
    if (this.$store.session.user.is_admin) {
      this.files.push({
        name: "soci-custom",
        label: "Soci da excel custom",
        is_std: true,
      });
    }
  },
  methods: {
    sicuri(f) {
      return !!confirm("Sicuri di voler importare il file " + f.name + "?");
    },
  },
};
</script>

<style lang="css"></style>
